<div class="flex flex-col gap-1">
    <p class="font-bold">Profile Image</p>
    <div class="flex flex-row sm:flex-row gap-2 sm:gap-4 sm:items-start text-xs sm:text-sm text-justify">
        <div class="min-w-28 w-28 min-h-28 h-28 sm:min-w-48 sm:w-48 sm:min-h-48 sm:h-48 bg-center bg-no-repeat rounded-full card-shadow" style="background-size: cover; background-image: url('{{ avatarUrl }}');"></div>
        <div class="flex flex-col gap-1 bg-slate-100 p-2 rounded-sm shadow-sm grow">
            <p>All users may use card art as their profile image. Right-click (or press and hold on mobile) almost any card and click <i>'Set as Profile Image'.</i></p>
            <p>Upgraded users may upload a picture as long as it is under 1 MB in size.</p>
            <p></p>
            <input #fileUploadInput (change)="onFileSelected(fileUploadInput)" type="file" class="hidden" [attr.accept]="validExtensions">
            <button (click)="fileUploadInput.click()"  class="p-1 bg-slate-50 rounded-sm shadow-sm hover:text-ponder-link hover:stroke-ponder-link hover:cursor-pointer border border-transparent hover:border-ponder-link disabled:text-slate-500 disabled:hover:text-slate-500 disabled:hover:cursor-default disabled:hover:border-transparent" [disabled]="!canUploadCustomImage || isUploading">
                @if (!isUploading) {
                    Upload Image
                } @else {
                    <busy-spin [small]="true"></busy-spin>
                }
            </button>
            @if (fileSizeError || fileExtensionError || uploadError) {
                <div class="flex flex-col gap-1 text-xs sm:text-sm p-1 border border-red-600 text-red-600 rounded">
                    @if (fileSizeError) {
                        <p>Error: File is too large!</p>
                    }
                    @if (fileExtensionError) {
                        <p>Error: File is an invalid format!</p>
                    }
                    @if (uploadError) {
                        <p>Uh oh! Something went wrong! If this issue persists, <a class="text-red-500 hover:text-red-400" href="/about#contact">please contact us.</a></p>
                    }
                </div>
            }
        </div>
    </div>
</div>